<div *ngIf="saving">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>

<div *ngIf="!saving">
	<div class="grid" *ngIf="enableLogWarning">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<p-tag icon="pi cm-alert" [value]="('LOGS_NOT_ENABLE_WARNING' | translate)" severity="warning"></p-tag>
		</div>
	</div>
	<form [formGroup]="filterGroup">
		<div class="grid mt-0 px-3">
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'START_DATE_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="startDateTime" [showButtonBar]="true"
							placeholder="{{'START_DATE_TIME' | translate}}" id="events-input-deviceFilter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right" [minDate]="minDate" [maxDate]="maxDate"
							[defaultDate]="today" [showTime]="true" [hourFormat]="24">
						</p-calendar>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'END_DATE_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-calendar [showIcon]="true" formControlName="endDateTime" [showButtonBar]="true"
							placeholder="{{'END_DATE_TIME' | translate}}" id="events-input-deviceFilter"
							[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
							inputStyleClass="pl-6 border-noround-right" [minDate]="minDate" [defaultDate]="today"
							[maxDate]="maxDate" [showTime]="true" [hourFormat]="24">
						</p-calendar>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'USER' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<span class="p-input-icon-left" [class]="dynamicInputTextWidth()">
							<i class="pi cm-search"></i>
							<input formControlName="searchFilter" pInputText type="text" [ngClass]="dynamicInputTextWidth()"
								class="pr-6" id="supportrequest-rbelog-input-search" placeholder="{{ 'SEARCH' | translate }}"
								maxlength="254" />
						</span>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'COMMAND_DEVICE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown [options]="accessType" formControlName="type" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5" id="events-input-deviceFilter"
							placeholder="{{ 'SELECT_ACCESS_TYPE' | translate }}">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex justify-content-center">
									<div>{{section.label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'OUTPUT_AUTOMATIONS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown [options]="functionList" formControlName="function" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5" id="events-input-deviceFilter">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.Label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex align-items-center justify-content-center">
									<div>{{section.Label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div [class]="col4Responsive()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'EVENTS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-dropdown [options]="accessResult" formControlName="result" [ngClass]="dynamicInputTextWidth()"
							styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5" id="events-input-deviceFilter"
							placeholder="{{ 'SELECT_RESULT' | translate }}">
							<ng-template let-item pTemplate="selectedItem">
								<div class="item flex align-items-center justify-content-center">
									<div class="flex align-items-center">{{ item.label | translate }}</div>
								</div>
							</ng-template>
							<ng-template let-section pTemplate="item">
								<div class="item flex align-items-center justify-content-center">
									<div>{{section.label | translate }}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>
			</div>
			<div [class]="col2Responsive()">
				<div class="flex">
					<button pButton pRipple icon="pi cm-reload" label="{{ 'REFRESH' | translate }}" (click)="refresh()"
						class="p-button-primary text-normal border-transparent font-medium py-1">
					</button>
				</div>
			</div>
			<div [class]="col2Responsive()">
				<div class="flex">
					<button pButton pRipple icon="pi cm-download" label="{{ 'EXPORT' | translate }}" (click)="exportToCsv()"
						class="p-button-primary text-normal border-transparent font-medium py-1" [disabled]="logs.length<=0">
					</button>
				</div>
			</div>
		</div>
	</form>

	<div class="grid mt-0">
		<p-confirmDialog #confDialog>
			<ng-template pTemplate="footer">
				<div class="col-12 flex justify-content-center">
					<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
						(click)="confDialog.accept()">
					</button>
					<button type="button" pButton *ngIf="rejectButtonVisible" [label]="confDialog.rejectButtonLabel"
						[ngClass]="rejectButtonStyle" (click)="confDialog.reject()">
					</button>
				</div>
			</ng-template>
		</p-confirmDialog>
		<div class="col-12">
			<p-table #tableRbeLogAccessList dataKey="id" [value]="logs" [totalRecords]="resultLength" [rows]="pageSize"
				[lazy]="true" [loading]="logsLoading" [paginator]="true" (onLazyLoad)="loadLogs($event)"
				[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[autoLayout]="true" sortField="EventDate" [sortOrder]="-1" responsiveLayout="stack">
				<ng-template pTemplate="header">
					<tr>
						<th>
							<div pSortableColumn="EventDate" class="flex align-items-center justify-content-center">
								{{ 'EVENT_DATE' | translate }}
								<p-sortIcon field="EventDate"></p-sortIcon>
							</div>
						</th>
						<th>
							<!-- <div pSortableColumn="Source" class="flex align-items-center justify-content-center"> -->
							<div class="flex align-items-center justify-content-center">
								{{ 'USER' | translate }}
								<!-- <p-sortIcon field="Source"></p-sortIcon> -->
							</div>
						</th>
						<th>
							<!-- <div pSortableColumn="Passage" class="flex align-items-center justify-content-center"> -->
							<div class="flex align-items-center justify-content-center">
								{{ 'COMMAND_DEVICE' | translate }}
								<!-- <p-sortIcon field="Passage"></p-sortIcon> -->
							</div>
						</th>
						<th>
							<div pSortableColumn="Result" class="flex align-items-center justify-content-center">
								{{ 'LOG_RESULT' | translate }}
								<p-sortIcon field="Result"></p-sortIcon>
							</div>
						</th>
						<th>
							<!-- <div pSortableColumn="Type" class="flex align-items-center justify-content-center"> -->
							<div class="flex align-items-center justify-content-center">
								{{ 'OUTPUT_AUTOMATIONS' | translate }}
								<!-- <p-sortIcon field="Type"></p-sortIcon> -->
							</div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-row>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'EVENT_DATE' | translate }}</span>{{ row.EventDate |
							localizedDate: 'medium':'UTC' }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'USER' | translate }}</span>{{ userData(row) }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'COMMAND_DEVICE' | translate }}</span>{{
							passageData(row) }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'LOG_RESULT' | translate }}</span>
							<p-tag *ngIf="row.Result === 1" value="{{ getResult(row.Result) }}" severity="success"></p-tag>
							<p-tag *ngIf="row.Result === 2 || row.Result === 3 || row.Result === 4"
								value="{{ getResult(row.Result) }}" severity="danger"></p-tag>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'OUTPUT_AUTOMATIONS' | translate }}</span>{{
							getAutomationActive(row) }}
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

</div>